import { render, staticRenderFns } from "./CommissionActionMassUnapprove.vue?vue&type=template&id=4cc25ac8&"
import script from "./CommissionActionMassUnapprove.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionMassUnapprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports